import { inject, Injectable } from '@angular/core';
import { isInternalStateRouteUrl } from '@state-routing/config/state-routing.config';
import { SessionStorageService } from './session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationStore {
  private readonly sessionStorage = inject(SessionStorageService);

  private readonly lastUrlKey: string = 'lastURL';
  private readonly backUrlKey: string = 'backURL';

  public setLastUrl(url: string): void {
    if (!isInternalStateRouteUrl(url)) return;

    this.sessionStorage.setItem(this.lastUrlKey, url);
  }

  public getLastUrl(): string | null {
    return this.resolveStoredUrl(this.lastUrlKey);
  }

  public setBackUrl(url: string): void {
    if (!isInternalStateRouteUrl(url)) return;

    this.sessionStorage.setItem(this.backUrlKey, url);
  }

  public getBackUrl(): string | null {
    return this.resolveStoredUrl(this.backUrlKey);
  }

  public clearBackUrl(): void {
    this.sessionStorage.removeItem(this.backUrlKey);
  }

  public resolveReturnUrl(defaultUrl: string): string {
    return this.getBackUrl()
      || this.getLastUrl()
      || (isInternalStateRouteUrl(defaultUrl) ? defaultUrl : '/avatar');
  }

  private resolveStoredUrl(key: string): string | null {
    const url: string | null = this.sessionStorage.getItem(key);
    if (url === null || isInternalStateRouteUrl(url)) return url;

    this.sessionStorage.removeItem(key);
    return null;
  }
}
